import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\DuplicateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/DuplicateTemplateDashboardController.php
* @route '/api/template-dashboard/duplicate'
*/
const DuplicateTemplateDashboardController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateTemplateDashboardController.url(options),
    method: 'post',
})

DuplicateTemplateDashboardController.definition = {
    methods: ["post"],
    url: '/api/template-dashboard/duplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\DuplicateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/DuplicateTemplateDashboardController.php
* @route '/api/template-dashboard/duplicate'
*/
DuplicateTemplateDashboardController.url = (options?: RouteQueryOptions) => {
    return DuplicateTemplateDashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\DuplicateTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/DuplicateTemplateDashboardController.php
* @route '/api/template-dashboard/duplicate'
*/
DuplicateTemplateDashboardController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateTemplateDashboardController.url(options),
    method: 'post',
})

export default DuplicateTemplateDashboardController